<ng-container *ngIf="wil">
	<div
		#rootWrapper
		class="inline-pass-card-wrapper"
		style="z-index: 501 !important; height: 412px"
		[style.background-image]="gradient"
		ondragstart="return false">
		<div class="pass-card-header">
			<div class="header-content">
				<div class="header-info">
					<img class="pass-card-header-icon" [src]="wil.icon | resolveAsset" />
					<div class="pass-card-header-text">{{ wil.destination.title }}</div>
				</div>
				<app-icon-button [srcString]="optionsIcon" [onDarkShade]="true" [size]="20" (clickEvent)="showOptions($event)"></app-icon-button>
			</div>
			<mat-divider></mat-divider>
		</div>

		<div class="inline-pass-card-content">
			<div class="travel">
				<app-travel-view [pass]="wil"></app-travel-view>
			</div>

			<div class="button" style="height: 110px">
				<ng-container *ngIf="!wil.isReadyToStart(); else wilCardButton">
					<mat-divider></mat-divider>
					<ng-template #positionInLine>
						<div style="font-weight: bold; position: relative; margin-top: 36px !important; display: flex; justify-content: center">
							<img class="ds-mr-10" [src]="'./assets/Clock (White).svg' | resolveAsset" alt="Clock face" />
							<span>{{ line_position | position }} in line</span><span style="width: 20px; text-align: left" #waitingDots></span>
						</div>
					</ng-template>

					<ng-template #teacherHistoryPager>
						<app-pager [pages]="2" [page]="2">
							<div class="page-1 teacher-details" [attr.data-motion-translate]="(frameMotion$ | async).direction">
								<span class="bold">Pass Created</span> <br />
								<span class="smaller" style="width: 200px; display: block; margin: 0 auto"
									>by {{ getUserName }} - {{ wil.created | date : 'EE, h:mm a' }}</span
								>
							</div>

							<div class="page-2 teacher-details" [attr.data-motion-translate]="(frameMotion$ | async).direction">
								<div style="font-weight: bold; position: relative; margin-top: 20px !important; display: flex; justify-content: center">
									<img class="ds-mr-10" [src]="'./assets/Clock (White).svg' | resolveAsset" alt="Clock face" />
									<span>{{ line_position | position }} in line</span><span style="width: 20px; text-align: left" #waitingDots></span>
								</div>
							</div>
						</app-pager>
					</ng-template>

					<ng-container *ngIf="!forStaff; else teacherHistoryPager" [ngTemplateOutlet]="positionInLine"></ng-container>
				</ng-container>

				<ng-template #wilCardButton>
					<app-card-button [width]="'288px'" [height]="'81px'" [gradientColor]="wil?.color_profile.gradient_color" [overlayWidth]="'0px'">
						<ng-container *ngIf="requestLoading; else frontOfLine">
							<div class="end-pass-content" style="width: auto !important">
								<mat-spinner [color]="'accent'" [diameter]="35"></mat-spinner>
							</div>
						</ng-container>

						<ng-template #frontOfLine>
							<div
								class="end-pass-content ds-flex-center-between"
								style="justify-content: space-around; width: 100%; border-radius: 8px"
								(click)="startPass()">
								<sp-timer-spinner
									customToolTip
									[contentTemplate]="passAttemptTooltip"
									[maxSeconds]="30"
									[startAt]="remainingAttemptSeconds"
									[showNumber]="true"
									(pulse)="readyToStartTick($event)">
								</sp-timer-spinner>
								<span>Start Pass</span>
								<img style="width: 25px" [src]="'./assets/Chevron Right (White).svg' | resolveAsset" alt="Right Arrow" />

								<ng-template #passAttemptTooltip>
									<div class="ds-tooltip" style="width: 200px">
										<span>
											You have {{ acceptingPassTimeRemaining }} sec left to start your pass or
											{{ wil.missed_start_attempts === 1 ? 'your pass will be deleted' : 'you will be sent back in line' }}.</span
										>
									</div>
								</ng-template>
							</div>
						</ng-template>
					</app-card-button>
				</ng-template>
			</div>
		</div>
	</div>

	<div class="leave-browser-hint" *ngIf="user?.isStudent() && !dialogData?.nextInLine">
		<div class="wrapper">
			<img class="report-icon" [src]="'./assets/Report (Yellow-Black).svg' | resolveAsset" />
			<p>Your browser tab will flash when it’s your turn to go — feel free to leave the page.</p>
		</div>
	</div>

	<div class="student-footer-info" *ngIf="openedFromPassTile" [style.margin-top]="isKiosk ? '110px' : '160px'">
		<app-student-passes [pass]="wil" [profile]="wil.student"></app-student-passes>
	</div>
</ng-container>
